export enum ToolbarAction {
    NONE,
    EMOJIS,
    PHOTOS,
    STICKERS,
}
